module.exports = __webpack_public_path__ + "static/img/outlook2.877ff05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/outlook2.png
// module id = 1429
// module chunks = 1